import { useEffect, useState } from 'react';
import axios from 'axios';

// sms_enabled from GET /api/company: whether any SMS Phase 2 UI exists at all.
//
// A PRESENTATION flag only. Every /api/sms route enforces SMS_ENABLED itself
// and answers 404 when it is off, so a client that ignored this would gain
// nothing. A missing key, or a failed request, is treated as off.
//
// One request per page load, shared by every component that asks.
let pending = null;

const loadSmsEnabled = () => {
  if (!pending) {
    pending = axios.get(`${process.env.REACT_APP_API_URL}/api/company`)
      .then((response) => response.data?.sms_enabled === true)
      .catch(() => {
        pending = null;
        return false;
      });
  }
  return pending;
};

export default function useSmsEnabled() {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let live = true;
    loadSmsEnabled().then((value) => { if (live) setEnabled(value); });
    return () => { live = false; };
  }, []);
  return enabled;
}
